import { useMutation } from "@tanstack/react-query";
import { writeIt } from "@/services/review.service";
import { WriteItRequest } from "@/types/review.types";

export const useWriteIt = () => {
    return useMutation({
        mutationFn: (request: WriteItRequest) => writeIt(request),
    });
};
